import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-booking-details-door-step',
  templateUrl: './booking-details-door-step.component.html',
  styleUrls: ['./booking-details-door-step.component.scss']
})
export class BookingDetailsDoorStepComponent implements OnInit, OnChanges {

  @Input()
  appCopy;

  @Input()
  selectedLanguage;
  
  @Input()
  adminBookingDetails;

  @Input()
  adminBookingDetailsLoaded;

  @Input()
  bookingRef;

  public extraBagDoorstepPayment = null;
  public currencySymbol = ''

  constructor(
    private _router: Router
  ) {}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.adminBookingDetailsLoaded !== 'undefined') {
      if (changes.adminBookingDetailsLoaded.currentValue) {
        this.extraBagDoorstepPayment = this.adminBookingDetails.bookingJourneyDetails[0].extraBagDoorstepPayment;
        this.currencySymbol = this.adminBookingDetails.bookingJourneyDetails[0].paymentDetails.currencySymbol;
      }
    }
  }

  redirectToSettings(event, type) {
    event.preventDefault();
    const redirectUrl = `my-account/settings-override?ref=${this.bookingRef}&type=${type}`;
    this._router.navigateByUrl(redirectUrl);
  }
}
